import React from 'react';

const GooglePlayBadge = ({ url, className = '' }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-block ${className}`}
  >
    <img
      src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
      alt="Get it on Google Play"
      className="h-14"
    />
  </a>
);

export default GooglePlayBadge;
